import React from 'react';
import { POLICIES } from '../data/policies';

export default function PolicyPage({ type }) {
  const policy = POLICIES[type] || POLICIES.terms;
  return (
    <div style={s.page}>
      <div style={s.header}>
        <h1 style={s.h1}>{policy.title}</h1>
        <p style={s.sub}>DHAMO LLC · Thankful Money · Effective April 22, 2026</p>
      </div>
      <div style={s.card}>
        {policy.sections.map(([title, body]) => (
          <section key={title} style={s.section}>
            <h2 style={s.h2}>{title}</h2>
            <p style={s.p}>{body}</p>
          </section>
        ))}
        <div style={s.notice}>
          Questions may be sent to support@thankfulmoney.com.
        </div>
      </div>
    </div>
  );
}

const s = {
  page: { maxWidth: 880 },
  header: { marginBottom: 20 },
  h1: { fontSize: 24, fontWeight: 800, marginBottom: 6 },
  sub: { fontSize: 13, color: 'var(--t3)' },
  card: {
    background: 'var(--bg-1)', border: '1px solid var(--border)',
    borderRadius: 'var(--rl)', padding: '26px 30px',
  },
  section: { paddingBottom: 20, marginBottom: 20, borderBottom: '1px solid var(--border-s)' },
  h2: { fontSize: 15, fontWeight: 700, marginBottom: 8 },
  p: { fontSize: 13, color: 'var(--t2)', lineHeight: 1.75 },
  notice: { fontSize: 12, color: 'var(--t3)', lineHeight: 1.6 },
};
